interface RewardfulInterface {
  referral?: string;
  coupon?: { id: string };
}

declare global {
  function rewardful(event: 'ready', callback: () => void): void;
  function rewardful(event: 'convert', input: { email: string }): void;
  const Rewardful: RewardfulInterface | undefined;
}

export function getRewardful(): RewardfulInterface | undefined {
  if (typeof Rewardful === 'undefined') {
    return undefined;
  }
  return Rewardful;
}
